import { useFetchBrandKitsWithColors } from 'reporting-data/hooks/useFetchBrandKitsWithColors';
import { Palette, BrandKitScheme } from '../visualize/color/palettes';
import { List } from 'immutable';
import { useMemo } from 'react';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
export const useFetchSnowflakeBrandKitColorPalettes = (brandKitColorMap, deferred = false) => {
  const asyncBrandKitsWithColorsData = useFetchBrandKitsWithColors(deferred);
  const asyncBrandKitsWithColors = isSucceeded(asyncBrandKitsWithColorsData) && asyncBrandKitsWithColorsData.data;
  const brandKitsWithColor = brandKitColorMap || asyncBrandKitsWithColors;
  const kitColorPalettes = useMemo(() => {
    const shouldDisplayBrandKitColorPalettes = brandKitsWithColor && Object.keys(brandKitsWithColor).length > 0;
    const brandKitColorPalettes = [];
    if (shouldDisplayBrandKitColorPalettes) {
      for (const key in brandKitsWithColor) {
        if (brandKitsWithColor[key].colorPalette) {
          const brandKit = brandKitsWithColor[key];
          const scheme = BrandKitScheme({
            colors: brandKit.colorPalette ? brandKit.colorPalette.map(palette => ({
              key: palette.color,
              value: palette.color
            })) : []
          });
          const kitPalette = Palette({
            id: key,
            label: brandKit.name,
            scheme
          });
          brandKitColorPalettes.push(kitPalette);
        }
      }
    }
    return brandKitColorPalettes;
  }, [brandKitsWithColor]);
  const snowflakeBrandKitPaletteMap = useMemo(() => List.of(...kitColorPalettes).toOrderedMap().mapKeys((_, v) => v && v.id), [kitColorPalettes]);
  return {
    snowflakeBrandKitPaletteMap,
    isLoading: !deferred && brandKitColorMap === undefined && isLoading(asyncBrandKitsWithColorsData)
  };
};